/**
 * IM头部
 * author: jiaheming
 * date: 2019/06/12
 */
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import arrow from '../../static/images/arrow.png';
import bg from '../../static/images/header-bg.png';
import msg from '../../static/images/header-icon.png';

const HeaderStyle = styled.div`
    position: relative;
    width: 100%;
    height: 64px;
    background: linear-gradient(270deg, rgba(123, 152, 247, 1) 0%, rgba(45, 128, 241, 1) 100%);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: left bottom;

    .im-header-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;
const InfoStyle = styled.div`
    display: flex;
    width: 100%;
    height: 100%;

    .im-header-icon {
        flex: none;
        width: 60px;
        height: 100%;
        img {
            width: 26px;
            height: 21px;
            margin: 20px;
        }
    }

    .im-header-title {
        flex: auto;
        height: 100%;
        width: 64px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 64px;
    }

    .im-header-arrow {
        flex: none;
        width: 60px;
        height: 100%;

        img {
            width: 16px;
            height: 16px;
            margin: 24px;
            cursor: pointer;
        }
        z-index: 999;
    }
`;

class IMHeader extends React.Component {
    render() {
        return (
            <HeaderStyle>
                {/* <img className='bg' src="static/images/header-bg.png" alt=""/> */}
                <img className="im-header-bg" src={bg} alt="" />
                <InfoStyle>
                    <div className="im-header-icon">
                        <img src={msg} alt="" />
                    </div>
                    <div className="im-header-title">即时信息</div>
                    <div className="im-header-arrow">
                        <a
                            href="javascript:"
                            onClick={() => {
                                this.props.closeCallback();
                            }}
                        >
                            <img src={arrow} alt="" />
                        </a>
                    </div>
                </InfoStyle>
            </HeaderStyle>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps)(IMHeader);
